import { render, staticRenderFns } from "./ImportedMailing.vue?vue&type=template&id=15ceca91"
import script from "./ImportedMailing.vue?vue&type=script&lang=js"
export * from "./ImportedMailing.vue?vue&type=script&lang=js"
import style0 from "./ImportedMailing.vue?vue&type=style&index=0&id=15ceca91&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports